module.exports = __webpack_public_path__ + "a8acefbd52963d4b06c4437633404b45.pdf";